import React, { useState } from 'react';
import validator from 'validator';
import { useMutation } from 'react-query';
import { withStyles } from '@material-ui/core/styles';

import MuiTableRow from '@material-ui/core/TableRow';
import MuiTableCell from '@material-ui/core/TableCell';
import MuiTextField from '@material-ui/core/TextField';

import RowButtons from './row-buttons';

import HoverLink from 'components/HoverLink';
import AccountStatusCell from './account-status-cell';
import TYPE from './PAYEE_TYPE.json';

import * as API from 'api';

const Payees = API.Payees();

const styles = () => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  edit: {
    fontSize: 'medium',
  },
  expandedRow: {
    backgroundColor: '#f3f3f3',
  },
  loadWrapper: {
    display: 'flex',
    justifyContent: 'center',
    margin: '1rem 0',
  },
  buttonCell: {
    whiteSpace: 'nowrap',
  },
  totalsTable: {
    marginTop: '1rem',
  },
  fileCell: {
    maxWidth: '300px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  totalsCell: {
    border: 0,
    fontWeight: 'bold',
  },
});

const stripeDashboardPrefix = 'https://dashboard.stripe.com/connect/accounts/';

const PayeesTableRow = props => {
  const { classes, row, editing, onEditChange, refetchPayees } = props;

  const [name, setName] = useState(row.full_name);
  const [email, setEmail] = useState(row.email);

  const { mutate: deletePayee, isLoading: isDeleting } = useMutation(id => Payees.remove(id), {
    onSuccess: () => refetchPayees(),
    onError: err => alert(err?.data?.detail || err?.data),
  });

  const { mutate: patchPayee, isLoading: isSaving } = useMutation(({ id, data }) => Payees.update(id, data), {
    onSuccess: () => {
      onEditChange(null);
      refetchPayees();
    },
    onError: err => alert(err?.data?.detail || err?.data),
  });

  const onSave = () => patchPayee({ id: row.id, data: { full_name: name, email } });

  return (
    <MuiTableRow className={classes.root}>
      <MuiTableCell component="th" scope="row">
        {row.id}
      </MuiTableCell>
      <MuiTableCell>
        {editing ? <MuiTextField value={email} onChange={({ target: { value } }) => setEmail(value)} /> : row.email}
        <br />
        <HoverLink href={`${stripeDashboardPrefix}${row.stripe_account_id}`} target="_blank">
          {row.stripe_account_id}
        </HoverLink>
      </MuiTableCell>
      <MuiTableCell style={{ width: '20%' }}>
        {editing ? <MuiTextField value={name} onChange={({ target: { value } }) => setName(value)} /> : row.full_name}
      </MuiTableCell>
      <MuiTableCell>{row.type}</MuiTableCell>
      <MuiTableCell>{row.group_name}</MuiTableCell>
      <AccountStatusCell align="justify" row={row} />
      <MuiTableCell style={{ width: '10%' }} className={classes.buttonCell} align="right">
        <RowButtons
          canDelete={!row.hasSplits}
          isGroup={row.type === TYPE.GROUP}
          editing={editing}
          onEditChange={editing => onEditChange(editing ? row.id : null)}
          onDelete={() => deletePayee(row.id)}
          onSave={onSave}
          isMutating={isSaving || isDeleting}
          isValid={!validator.isEmpty(name || '')}
        />
      </MuiTableCell>
    </MuiTableRow>
  );
};

export default withStyles(styles)(PayeesTableRow);
